import client from '../utils/client';
import { cityUrl } from '../store/constants/api';
import { cookieConstants } from "../store/constants";
import { Cookies } from "react-cookie";

const cookies = new Cookies();

export const cityService = {
  getCities,
  getProvinces
}

function getCities(provinceID) {
  return client.post(cityUrl, { id: provinceID })
    .then((response) => {
      return response;
    })
    .catch(handleResponse);
}

function getProvinces() {
  return client.get(cityUrl)
    .then((response) => {
      return response;
    })
    .catch(handleResponse);
}

function logout() {
  cookies.remove(cookieConstants.TOKEN, { path: "/" });
  cookies.remove(cookieConstants.USER, { path: "/" });
}

function handleResponse(response) {
  response = response.response
  var data = response.data;
  if (!response.ok) {
    if (response.status === 401) {
      logout();
      window.location.reload(true);
    }
    const error = data.errors;
    return Promise.reject(error);
  }

  return data;
}